import React, { Component } from 'react'
import '../../css/BisharatMain.css';
import Moment from 'moment';
import Calendar from 'react-calendar';
import MemberDataService from '../../services/MemberDataService';
import translate from '../../languages/translate';


export default class PartnerCreate extends Component {
    constructor() {
        super()
        this.state = {
            "memberId": "",
            "name": "",
            "birthdate": new Date(),
            "fatherName": "",
            "familyName": "",
            "identity": "",
            "partnerId": "",
            "phoneNumber": "",
            "gender": '',
            "motherName": '',
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }


    componentDidMount() {
        const { match: { params } } = this.props;
        const memberId = params.id;
                this.setState({ memberId : memberId});      
    }

    createPartner(partnerData) {
        MemberDataService.addPartner(this.state.memberId,partnerData,)
            .then((response) => {

                  this.setState({
                        message: translate("add-partner-succesfully"),
                        successful: true
                    });
            },
                error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    this.setState({
                        successful: false,
                        message: resMessage
                    });
                }
            );
    }



    onChangeDate = birthdate => this.setState({birthdate});

    onChange(event) {
        //that means that every event.target. name (the name in the elements) to assign the value to it. 
        this.setState({ [event.target.name]: event.target.value })
    }

    onSubmit(event) {
        event.preventDefault()
        const newPartner = {
            address: this.state.address,
            birthdate: Moment(this.state.birthdate).format('DD-MM-YYYY'),
            fatherName: this.state.fatherName,
            motherName: this.state.motherName,
            identity: this.state.identity,
            familyName: this.state.familyName,
            gender: this.state.gender,
            name: this.state.name,
            phoneNumber: this.state.phoneNumber,
        };
        this.createPartner(newPartner);
    }



    render() {

        return (
            <div className="mainCreate">
                <div className="top-container-forms  membercreate-topform">
                    <div className="create-form membercreate-form">

                        <h1>{translate("addPartner")}  </h1>

                        <form onSubmit={this.onSubmit}>
                            <div className="form-group-create">
                                <h5> الأسم </h5>
                                <input
                                type="text"
                                    name="name" placeholder="Name"
                                    value={this.state.name}
                                    onChange={this.onChange}
                                />

                            </div>
                            <div className="form-group-create">
                                <h5> اسم الأب </h5>
                                <input type="text" className="form-control-form-cont" name="fatherName" placeholder="Father Name"
                                    value={this.state.fatherName}
                                    onChange={this.onChange}

                                />

                            </div>
                            <div className="form-group-create">
                                <h5> اسم الام </h5>
                                <input type="text" className="form-control-form-cont" name="motherName" placeholder="Mother Name"
                                    value={this.state.motherName}
                                    onChange={this.onChange}
                                />
                            </div>

                            <div className="form-group-create">
                                <h5> اسم العائلة </h5>
                                <input type="text" className="form-control-form-cont" name="familyName" placeholder="Family Name"
                                    value={this.state.familyName}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div className="form-group-create">
                                <h5> رقم الهاتف </h5>
                                <input type="text" className="form-control-form-cont" name="phoneNumber" placeholder="Phone Number"
                                    value={this.state.phoneNumber}
                                    onChange={this.onChange}
                                />
                            </div>
                           

                           
                            <div className="form-group-create">
                                <h5> تاريخ الميلاد </h5>
                                   <Calendar className="react-calendar"
                                    onChange={this.onChangeDate}
                                    value={this.state.birthdate}
                                    />
                            </div>
                    
                            <input type="submit" value="ارسال" className="btn btn-primary btn-block mt-4" />

                            {this.state.message && (
                                <div className="form-group">
                                    <div
                                        className={
                                            this.state.successful
                                                ? "alertSuccess"
                                                : "alertDanger"
                                        }
                                        role="alert"
                                    >
                                        {this.state.message}
                                    </div>
                                </div>
                            )}

                        </form>
                        <button className="btn" onClick={this.props.history.goBack}> {translate("back")}  </button>
                    </div>

                </div></div>


        )
    }
}
